// React
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

// Utils
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { keyEmptyCheck } from 'aurora-utils/utils';

// Components
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Hidden from '@material-ui/core/Hidden';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import messages from 'aurora-translations';
import UplaodIcon from 'aurora-images/uplaodIcon.svg';
import PDFIcon from 'aurora-images/PDF.svg';
import PlusIconBlack from 'aurora-images/plusIconBlack.svg';
import { getPMADocuments } from 'aurora-composition/modules/pma/actions';

// Styles
import AppendixModal from './AppendixModal';
import styles from './styles';

function ADGMDocumentsList(props) {
  const {
    handleChange,
    appendixList,
    saveAppendices,
    applicationId,
    documents,
    applicationType,
    handleUploadDocument,
    handleDownloadDocument,
    handleDeleteDocument,
    classes,
    title,
    isPMABank,
  } = props;

  const dispatch = useDispatch();

  // For Appendices
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedAppendix, setSelectedAppendix] = useState({ index: appendixList?.length });
  const toggleModal = () => {
    setModalOpen(!isModalOpen);
    setSelectedAppendix({ index: appendixList?.length });
  };
  const submitAppendix = appendix => {
    const appendices = [...(appendixList || [])];
    if (appendix?.index >= 0)
      appendices[appendix.index] = {
        appendixEn: appendix.appendixEn,
        appendixAr: appendix.appendixAr,
      };
    else
      appendices.push({
        appendixEn: appendix.appendixEn,
        appendixAr: appendix.appendixAr,
      });
    handleChange({ appendixList: appendices });
    setModalOpen(false);
    saveAppendices && saveAppendices(appendices);
    setSelectedAppendix({});
  };
  const remove = index => {
    const appendices = [...(appendixList || [])];
    appendices.splice(index, 1);
    handleChange({ appendixList: appendices });
  };

  // For Documents
  const handleUpload = e => {
    const { name, files } = e.target;
    const params = {
      applicationId,
      applicationType,
      documentType: 'PMA_OTHERS',
      subType: `${applicationId}_${applicationType}_${name}_${documents?.length + 1 || 1}`,
    };
    const formData = new FormData();
    formData.append('file', files[0]);
    handleUploadDocument && handleUploadDocument(formData, params);
  };
  const handleFileDownload = doc => {
    const payload = {
      applicationId: doc.applicationId,
      applicationType: doc.applicationType,
      documentType: doc.type,
      subType: doc.subType,
    };
    handleDownloadDocument && handleDownloadDocument(payload);
  };
  const handleFileDelete = (id, type, subType) => {
    // const query = `?applicationId=${applicationId}&applicationType=${applicationType}&documentType=${type}&subType=${subType}`;
    handleDeleteDocument(id, { applicationId, applicationType, documentType: type, subType });
  };

  const getDocuments = () => {
    return documents?.map((file, index) => (
      <div
        key={file.id}
        className={classNames(classes.fileContainer, {
          [classes.lastFile]: documents?.length < 5 && documents?.length === index + 1,
        })}
      >
        <Typography component='p' className={classes.fileNameWrapper}>
          <img src={PDFIcon} alt='pdf' />
          <Typography component='span' className={classes.fileName}>
            {file?.fileName}
          </Typography>
        </Typography>
        <div className={classes.btnHolder}>
          {false && (
            <Link
              component='button'
              variant='body2'
              className={classes.linkBtn}
              onClick={() => handleFileDownload(file)}
            >
              {keyEmptyCheck('download')}
            </Link>
          )}
          {true && (
            <Link
              component='button'
              variant='body2'
              className={classes.linkBtn}
              onClick={() => handleFileDelete(file.id, file.type, file.subType)}
            >
              {keyEmptyCheck('remove')}
            </Link>
          )}
        </div>
      </div>
    ));
  };

  const getAppendices = () => {
    return appendixList?.map((file, index) => (
      <div
        key={file.id}
        className={classNames(classes.fileContainer, {
          [classes.lastFile]: appendixList?.length < 5 && appendixList?.length === index + 1,
        })}
      >
        <Typography component='p' className={classes.fileNameWrapper}>
          <img src='/images/appendixDocument.svg' alt='icon' />
          <Typography component='span' className={classes.fileName}>
            <FormattedMessage {...messages.appendix} /> &nbsp;
            <FormattedMessage {...{ id: `appendix_${1}`, defaultMessage: `${index + 1}` }} />
          </Typography>
        </Typography>
        <div className={classes.btnHolder}>
          {false && (
            <Link
              component='button'
              variant='body2'
              className={classes.linkBtn}
              onClick={() => handleFileDownload(file)}
            >
              {keyEmptyCheck('download')}
            </Link>
          )}
          {true && (
            <Link component='button' variant='body2' className={classes.linkBtn} onClick={() => remove(index)}>
              {keyEmptyCheck('remove')}
            </Link>
          )}
        </div>
      </div>
    ));
  };

  useEffect(() => {
    dispatch(getPMADocuments(applicationId));
  }, []);
  return (
    <div>
      <div className={classes.contentArea}>
        <Paper variant='outlined' className={classes.paperCardFrame}>
          <div className={classes.titleHead}>
            <Typography variant='h6' component='h1' className={classes.Title}>
              {/* <FormattedMessage {...title} /> */}
              {title}
            </Typography>
          </div>

          {/* For Appendices */}
          {appendixList && (
            <div className={classes.fileWrapper}>
              <Hidden smDown>
                {isPMABank ? (
                  <Accordion>
                    <AccordionSummary
                      className={classes.accordionSummary}
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls='panel1a-content'
                      id='panel1a-header'
                    >
                      <Typography className={classes.accordionTitle}>
                        <img src='/images/appendixDocument.svg' alt='icon' width='27px' height='27px' />
                        <strong>{keyEmptyCheck('appendix')}</strong>
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>{getAppendices()}</AccordionDetails>
                  </Accordion>
                ) : (
                  <div className={classes.innerCardGrid}>{getAppendices()}</div>
                )}
              </Hidden>
              <div className={classes.innerCardGrid}>
                <Hidden mdUp>{getAppendices()}</Hidden>
                <Button
                  variant='outlined'
                  id='add_appendices'
                  onClick={toggleModal}
                  className={classNames(classes.btns, classes.addoccpantsBtn, classes.buttonMargin)}
                >
                  <img src={PlusIconBlack} alt='icon' />
                  {keyEmptyCheck('add_appendix')}
                </Button>
              </div>
            </div>
          )}

          {/* For Documents */}
          {documents && (
            <div className={classes.fileWrapper}>
              <Hidden smDown>
                {isPMABank ? (
                  <Accordion>
                    <AccordionSummary
                      className={classes.accordionSummary}
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls='panel1a-content'
                      id='panel1a-header'
                    >
                      <Typography className={classes.accordionTitle}>
                        <img src='/images/appendixDocument.svg' alt='icon' width='27px' height='27px' />
                        <strong>{keyEmptyCheck('other')}</strong>
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>{getDocuments()}</AccordionDetails>
                  </Accordion>
                ) : (
                  <div className={classes.innerCardGrid}>{getDocuments()}</div>
                )}
              </Hidden>
              <div className={classes.innerCardGrid}>
                <Hidden mdUp>{getDocuments()}</Hidden>
                <input
                  id='upload_documents'
                  name='upload_documents'
                  type='file'
                  accept='application/pdf'
                  multiple
                  hidden
                  onChange={handleUpload}
                />
                <label htmlFor='upload_documents'>
                  <Button
                    variant='outlined'
                    component='span'
                    id='upload_documents'
                    className={classNames(classes.btns, classes.addoccpantsBtn, classes.buttonMargin)}
                  >
                    <img src={UplaodIcon} alt='icon' />
                    {keyEmptyCheck('upload_document')}
                  </Button>
                </label>
              </div>
            </div>
          )}
        </Paper>

        {/* Appendices Modal */}
        {isModalOpen && (
          <AppendixModal
            submitAppendix={submitAppendix}
            appendix={selectedAppendix}
            isOpen={isModalOpen}
            onClose={toggleModal}
          />
        )}
      </div>
    </div>
  );
}

ADGMDocumentsList.propTypes = {
  handleChange: PropTypes.func.isRequired,
  appendixList: PropTypes.array.isRequired,
  saveAppendices: PropTypes.func.isRequired,
  documents: PropTypes.array.isRequired,
  applicationId: PropTypes.number.isRequired,
  applicationType: PropTypes.string.isRequired,
  handleUploadDocument: PropTypes.func.isRequired,
  handleDownloadDocument: PropTypes.func.isRequired,
  handleDeleteDocument: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  isPMABank: PropTypes.object.isRequired,
};

export default withStyles(styles)(ADGMDocumentsList);
